import getAppSite from 'utils/getAppSite';

// USA legislators with no direct email also surface emails sent to their staffers.
const stakeholderIncludesStaffEmails = ({ email, categories } = {}) =>
  getAppSite() === 'usa' &&
  email === null &&
  (categories?.includes('State Senator') ||
    categories?.includes('US Representative') ||
    categories?.includes('US Senator'));

export default stakeholderIncludesStaffEmails;
